import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ModalHeader', null, { withChildren: true });
